module.exports = ".hierarchy-tree {\n    float: left;\n    width: 250px;\n    height: 100vh;\n    border-right: 1px solid #f5f5f5;\n}\n.hierarchy-tree:last-child {\n    margin-bottom: 10px;\n}\n.queryFilter {\n    font-size: 12px;\n    width: 235px;\n    border: 1px hidden;\n    color: #4b4a4a;\n    padding: 0ch;\n}\ninput.queryFilter:focus {\n    outline-width: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/hierarchy-tree/hierarchy-tree.component.css
// module id = ./src/app/view/hierarchy-tree/hierarchy-tree.component.css
// module chunks = main